import React from 'react';
import { FormattedMessage } from 'react-intl';

export const buildFooters = ({ classes, editable, visibleColumns = [] }) => ({
  rowSelector: {
    id: 'rowSelector',
    visible: editable
  },
  client: {
    id: 'client',
    fixed: true,
    visible: visibleColumns.includes('client'),
    align: 'right',
    className: classes.dynamicColumn
  },
  project: {
    visible: visibleColumns.includes('project'),
    className: classes.dynamicColumn
  },
  projectLeader: {
    visible: visibleColumns.includes('projectLeader'),
    className: classes.projectManager
  },
  date: {
    id: 'date',
    visible: visibleColumns.includes('date'),
    value: <FormattedMessage id="avaialbleToBillList.total" />,
    align: 'right'
  },
  amount: {
    id: 'amount',
    visible: visibleColumns.includes('amount'),
    align: 'right',
    flip: false
  },
  createBill: {
    id: 'createBill',
    visible: editable
  }
});
